<script lang="ts" setup>
  import type { ICategories } from '@/types/OrigDest'
  import useFSFDataLayer from '@/composables/data-layers/useFSFDataLayer'

  defineProps<{ categories: ICategories[] }>()

  const radioState = defineModel<string>()

  const suppressFsfLabelsTracking = inject<boolean>('suppressFsfLabelsTracking', false)
  const { pushFSFDataLayer } = useFSFDataLayer()

  function onOrigDestCategoriesClick(value: string) {
    if (suppressFsfLabelsTracking) return

    pushFSFDataLayer({
      generic_event_name: 'fsf_labels',
      event_category: 'destination_labels_click',
      event_action: value
    })
  }

  const origDestCategories = ref(null)
  onElementVisibleAtThreshold(origDestCategories, () => {
    if (suppressFsfLabelsTracking) return

    pushFSFDataLayer({
      generic_event_name: 'fsf_labels',
      event_category: 'destination_labels_seen'
    })
  })
</script>

<template>
  <div ref="origDestCategories">
    <RadioGroupRoot
      v-model="radioState"
      class="group flex gap-x-4 overflow-auto p-0.5"
      :aria-label="$t('origDest.categories.title')"
      @update:model-value="onOrigDestCategoriesClick"
    >
      <div
        v-for="item in categories"
        :key="`categoriesItem-origDest-${item.key}`"
        class="flex items-center"
      >
        <RadioGroupItem
          :value="item.key"
          data-test="radio"
          class="rounded-lg"
        >
          <span
            class="flex h-8 w-auto min-w-20 cursor-pointer items-center justify-center rounded-lg border px-4 text-subtitle-1 hover:bg-bt-green"
            :class="{ 'bg-bt-green': radioState === item.key }"
          >
            {{ item.value }}
          </span>
        </RadioGroupItem>
      </div>
    </RadioGroupRoot>
  </div>
</template>
